"use strict";
// tslint:disable
/**
 * Movie Revenue Estimation
 * Collection of methods surrounding movies revenue estimation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
class Configuration {
    constructor(param = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
}
exports.Configuration = Configuration;



//////////////////
// WEBPACK FOOTER
// ./typescript_client/dist/configuration.js
// module id = 392
// module chunks = 0